// Generated Module Configuration
const moduleConfig = {
  "moduleConfig": {
    "name": "Cloud Slicer",
    "description": "Add Files to Uplynk",
    "size": "xlarge",
    "theme": "uplynk",
    "endpoints": [
      {
        "root_url": "https://services.uplynk.com",
        "path": "/api2/cloudslicer/jobs/create",
        "method": "POST",
        "category": "Cloud Slicer",
        "parameters": {
          "args.description": {
            "type": "string",
            "examples": "Tears of steel",
            "required": false,
            "parentType": "object",
            "displayName": "Title",
            "placeholder": "",
            "helpText": "",
            "inputElement": "text"
          },
          "args.trim": {
            "type": "string",
            "examples": "0,3000",
            "required": false,
            "parentType": "object",
            "displayName": "Trim",
            "placeholder": "",
            "helpText": "",
            "inputElement": "text"
          },
          "args.slicer_args": {
            "type": "string",
            "examples": "-audiodesc \\\"English\\\" -atrack 0 -drm_mode none",
            "required": false,
            "parentType": "object",
            "displayName": "Slicer Args",
            "placeholder": "",
            "helpText": "",
            "inputElement": "text"
          },
          "source.url": {
            "type": "string",
            "examples": "https://www.dropbox.com/scl/fi/9qopbcyd15jei49v6seh2/Tears-of-Steel.mp4?rlkey=ac47bz4dwo72a4ogfh44sn108&dl=1",
            "required": true,
            "parentType": "object",
            "displayName": "url",
            "placeholder": "",
            "helpText": "",
            "inputElement": "text"
          }
        }
      }
    ],
    "callbacks": {
      '/api2/cloudslicer/jobs/create': {
        "afterResponse": {
          "actions": [
            // First action: Add entry to job state list showing we're starting
            {
              "action": 'appendState',
              "config": {
                "state": 'starting',
                "messageTemplate": {"title": "Starting Job", "value": "{jobId}"},
                "extractMapping": {
                  "jobId": 'data.job.id',
                  "progress_percent": 0
                }
              }
            },
            // Second action: Store initial job information in shared params
            {
              "action": 'updateSharedParams',
              "config": {
                "extractMapping": {
                  "job.id": 'data.job.id',
                  "job.created": 'data.job.created'
                }
              }
            },
            // Third action: Start tracking the job
            {
              "action": 'uplynkCentralInitiator',
              "configType": 'cloudslicer'
            }
          ]
        },
        "onError": {
          "actions": [
            // Error handling actions
            {
              "action": 'sendNotification',
              "config": {
                "message": 'Cloud Slicer API Error: {value}',
                "type": 'error',
                "extractPath": 'error.message'
              }
            },
            {
              "action": 'appendState',
              "config": {
                "state": 'error',
                "messageTemplate": {"title": "Job Failed", "value": "{errorMessage}"},
                "extractMapping": {
                  "errorMessage": 'error.message',
                  "progress_percent": 0
                }
              }
            }
          ]
        }
      }
    },
    "elements": []
  },
  "displayOrder": [
    {
      "endpointIndex": 0,
      "paramName": "args.description"
    },
    {
      "endpointIndex": 0,
      "paramName": "source.url"
    },
    {
      "type": "button",
      "elementId": "button_1741528109211"
    }
  ],
  "customElements": [
    {
      "id": "button_1741528109211",
      "type": "button",
      "label": "Apply",
      "variant": "primary",
      "action": "submit"
    }
  ]
};

export default moduleConfig;